import React from 'react';

import { EMPTY_CALENDAR_FILTERS } from '../calendarFilters.helpers';
import { useCalendarCategories } from './useCalendarCategories';
import { useCalendarFilterOptions } from './useCalendarFilterOptions';

export function useCalendarFilters(token, initialState = {}) {
  const { categories, categoryChecks, setCategoryChecked } = useCalendarCategories(
    token,
    initialState.categoryChecks,
  );
  const { pmas, members } = useCalendarFilterOptions(token);
  const [onlyWithHacs, setOnlyWithHacs] = React.useState(Boolean(initialState.onlyWithHacs));
  const [showSystemTasks, setShowSystemTasks] = React.useState(initialState.showSystemTasks !== false);
  const [advancedFilters, setAdvancedFilters] = React.useState(() => ({
    ...EMPTY_CALENDAR_FILTERS,
    pmaIds: [],
    memberIds: [],
    ...(initialState.advancedFilters || {}),
  }));
  return {
    categories,
    catChecks: categoryChecks,
    handleCategoryCheckChange: setCategoryChecked,
    onlyWithHacs,
    setOnlyWithHacs,
    setShowSystemTasks,
    showSystemTasks,
    advancedFilters,
    setAdvancedFilters,
    pmas,
    members,
  };
}
